import { CompanyType } from "src/app/generated/CrossPoint.IdentityManagement.Server";

export const COMPANY_TYPE_ICONS: { [key in CompanyType]: string } = {
  crossPoint: 'language',
  dealer: 'handshake',
  installer: 'handyman',
  retailer: 'storefront',
};